export enum PricingPer {
    ItemDefaultUnit = 1,
    PriceUnit = 2,
}
